import { defineMessage } from 'react-intl';

export const scope = 'app.containers.TippingTeamPage';

export default defineMessage({
  resourceNotPartOfTeam: {
    id: `${scope}.resourceNotPartOfTeam`,
    defaultMessage: 'This resource is currently not part of a team'
  },
  addResourceToTeam: {
    id: `${scope}.addResourceToTeam`,
    defaultMessage: 'Add this resource to your team'
  },
  createNewTeamWithUser: {
    id: `${scope}.createNewTeamWithUser`,
    defaultMessage: 'Create a new team using this Member'
  },
  addUserToTeam: {
    id: `${scope}.addUserToTeam`,
    defaultMessage: 'Add this member to your team'
  },
  createNewTeamWithResource: {
    id: `${scope}.createNewTeamWithResource`,
    defaultMessage: 'Create a new team using this resource'
  },
  moveResourceToTeam: {
    id: `${scope}.moveResourceToTeam`,
    defaultMessage:
      'This resource is already part of a team. Join the team with this resource to add or remove team members, or, claim this resource for your own team instead.'
  },
  resourceIsPartOfTeam: {
    id: `${scope}.resourceIsPartOfTeam`,
    defaultMessage: 'Team connection active with this resource'
  },
  moveUserToNewTeam: {
    id: `${scope}.moveUserToNewTeam`,
    defaultMessage: 'This user is already part of a team. Create a new team using this member'
  },
  moveUserToExistingTeam: {
    id: `${scope}.moveUserToExistingTeam`,
    defaultMessage:
      'This member is already part of a team. Join the team to take control and add or remove team members'
  },
  userIsPartOfTeam: {
    id: `${scope}.userIsPartOfTeam`,
    defaultMessage: 'Team connection active with this member'
  },
  add: {
    id: `${scope}.add`,
    defaultMessage: 'Add'
  },
  toMyTeam: {
    id: `${scope}.toMyTeam`,
    defaultMessage: 'to my team'
  },
  youOwnThisCard: {
    id: `${scope}.youOwnThisCard`,
    defaultMessage:
      'This card belongs to you. Scan a card belonging to a resource or another colleague to create a team'
  },
  claimResource: {
    id: `${scope}.claimResource`,
    defaultMessage: 'Claim Resource'
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel'
  },
  leaveTeamConfirmation: {
    id: `${scope}.leaveTeamConfirmation`,
    defaultMessage: 'Are you sure you wish to leave this team?'
  },
  claimResourceConfirmation: {
    id: `${scope}.claimResourceConfirmation`,
    defaultMessage:
      'Are you sure you wish to proceed? Claiming this resource will create a new team. This action cannot be undone'
  },
  claimResourceInGroup: {
    id: `${scope}.claimResourceInGroup`,
    defaultMessage:
      'Claiming this resource will add it to your team'
  },
  addUserToTeamButton: {
    id: `${scope}.addUserToTeamButton`,
    defaultMessage: 'Add Member To Team'
  },
  createNewTeam: {
    id: `${scope}.createNewTeam`,
    defaultMessage: 'Create New Team'
  }
});
